import { MESSAGES } from 'constants/messages';

/**
 * Normalizes any error (Axios error, FastAPI error body, JS Error) into a
 * consistent shape the UI can rely on:
 *   { status, message, fieldErrors, code, raw }
 *
 * FastAPI typically returns:
 *   { detail: "message" }                         -> generic
 *   { detail: [{ loc, msg, type }, ...] }         -> validation (422)
 */
export const parseApiError = (error) => {
  // No response => network/timeout
  if (error && error.request && !error.response) {
    return {
      status: 0,
      message: MESSAGES.GENERIC.NETWORK_ERROR,
      fieldErrors: {},
      code: 'NETWORK_ERROR',
      raw: error,
    };
  }

  const response = error?.response;
  const status = response?.status ?? 0;
  const data = response?.data;

  let message = MESSAGES.GENERIC.UNEXPECTED_ERROR;
  const fieldErrors = {};

  if (data) {
    if (typeof data.detail === 'string') {
      message = data.detail;
    } else if (Array.isArray(data.detail)) {
      // FastAPI validation errors
      message = 'Please fix the highlighted fields.';
      data.detail.forEach((item) => {
        const field = Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : item.loc;
        if (field) fieldErrors[field] = item.msg;
      });
    } else if (typeof data.message === 'string') {
      message = data.message;
    }
  }

  // Status-specific fallbacks
  if (message === MESSAGES.GENERIC.UNEXPECTED_ERROR) {
    if (status === 401) message = MESSAGES.GENERIC.SESSION_EXPIRED;
    else if (status === 403) message = MESSAGES.GENERIC.FORBIDDEN;
    else if (status === 404) message = MESSAGES.GENERIC.NOT_FOUND;
    else if (status >= 500) message = MESSAGES.GENERIC.SERVER_ERROR;
  }

  return { status, message, fieldErrors, code: data?.code, raw: error };
};

export default parseApiError;
